var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M877.22 564.98H844v-92.34c0-136.84-111.46-248.16-248.46-248.16S347.16 335.8 347.16 472.64v92.34H314v-92.34c0-155.1 126.32-281.28 281.6-281.28s281.6 126.18 281.6 281.28z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M686.18 822.72h-97.68v-28.14h97.68c87.06 0 157.88-70.12 157.88-156.3h28.42c0 101.72-83.58 184.44-186.3 184.44z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M531.72 773.06m33.12 0l56.82 0q33.12 0 33.12 33.12l0 4.7q0 33.12-33.12 33.12l-56.82 0q-33.12 0-33.12-33.12l0-4.7q0-33.12 33.12-33.12Z",
    fill: "#686F77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M849.42 465.42h19.18a23.2 23.2 0 0 1 23.2 23.2v185.16a23.2 23.2 0 0 1-23.2 23.2h-19.18a93.02 93.02 0 0 1-93-92.98v-45.58a93.02 93.02 0 0 1 93.02-93.02z",
    fill: "#686F77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M850.3 448.88H874a40 40 0 0 1 40 40v180.52a40 40 0 0 1-40 40h-23.7a16.32 16.32 0 0 1-16.32-16.32V465.22a16.32 16.32 0 0 1 16.32-16.32z",
    fill: "#495057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M438.8 222.7a14.18 14.18 0 0 1 5.78-18.82l2-1.1a309.9 309.9 0 0 1 306.38 3.54l2 1.16a14.18 14.18 0 0 1 5.32 19l-29.3 54.14a14.2 14.2 0 0 1-19.78 5.42l-2.12-1.26a219.84 219.84 0 0 0-220.54-2.44l-2.16 1.22a14.2 14.2 0 0 1-19.68-6z",
    fill: "#868E96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.7 822l31.72-95.14a23.32 23.32 0 0 0-1.78-18.46A237.12 237.12 0 0 1 107 578c8.38-114.26 99.76-208 213.78-218.9a238 238 0 0 1 260 261.36c-11.2 111.48-101.52 201.3-213.02 212a237.32 237.32 0 0 1-126.62-22.36 23.04 23.04 0 0 0-15.9-1.68l-106.74 28a11.46 11.46 0 0 1-13.8-14.42zM98 842",
    fill: "#FCC419"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M342.52 795.18a195.48 195.48 0 0 1-85.6-19.52 64.24 64.24 0 0 0-27.72-6.38 62.32 62.32 0 0 0-15.82 2L158 786l14.94-44.82a63.8 63.8 0 0 0-4.52-50.18 197.62 197.62 0 0 1-22.94-108.34c6.94-94.68 83.28-172.86 177.56-181.86 6.5-0.62 13.1-0.94 19.56-0.94a197.74 197.74 0 0 1 19.72 394.46c-6.64 0.54-13.28 0.86-19.8 0.86z",
    fill: "#FFD43B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.98 597.46m-25.96 0a25.96 25.96 0 1 0 51.92 0 25.96 25.96 0 1 0-51.92 0Z",
    fill: "#F08C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.54 597.46m-25.96 0a25.96 25.96 0 1 0 51.92 0 25.96 25.96 0 1 0-51.92 0Z",
    fill: "#F08C00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M451.1 597.46m-25.96 0a25.96 25.96 0 1 0 51.92 0 25.96 25.96 0 1 0-51.92 0Z",
    fill: "#F08C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSupportIcon);
export default __webpack_public_path__ + "static/media/ChatSupportIcon.6b81ce5fd95bed2d09116b459f6960bc.svg";
export { ForwardRef as ReactComponent };